import {
  ListRequest,
  useAuthEntraGroupListQuery,
} from "@/services/backend/auth/api/entragroup-api";
import { ColumnDef } from "@tanstack/react-table";
import { Group } from "@/services/backend/auth/types/group";
import t from "@/lang/lang";
import { CompanyName } from "@/services/backend/company/components/company-name";
import {
  DataTable,
  DataTableContainer,
  useDataTableController,
} from "@/shared/components/tables/data-table";
import { RTKQueryErrorAlert } from "@/shared/components/errors/rtk-query-error-alert";
import { PutEntraGroupDialog } from "@/routes/base-data/auth/entra/entra-groups/_components/put-entra-group-dialog";
import { DeleteEntraGroupDialog } from "@/routes/base-data/auth/entra/entra-groups/_components/delete-entra-group-dialog";
import { BranchName } from "@/services/backend/company/components/branch-name";

export function EntraGroupsTable() {
  const { data, isLoading, error } = useAuthEntraGroupListQuery(
    {} as ListRequest,
  );

  const table = useDataTableController(columns, data?.groups ?? []);

  if (error) {
    return <RTKQueryErrorAlert error={error} />;
  }

  if (isLoading) {
    return (
      <DataTableContainer className="animate-pulse">
        <DataTable table={table} columns={columns} />
      </DataTableContainer>
    );
  }

  return (
    <DataTableContainer>
      <DataTable table={table} columns={columns} />
    </DataTableContainer>
  );
}

const columns: ColumnDef<Group>[] = [
  {
    header: t("ID der Entra Gruppe"),
    accessorKey: "id",
  },
  {
    header: t("Name der Entra Gruppe"),
    accessorKey: "name",
  },
  {
    header: t("Unternehmen"),
    cell: ({ row }) => {
      const group = row.original;
      return (
        <div className="flex flex-col">
          {group.companies.map((company) => (
            <CompanyName companyId={company} key={company} />
          ))}
        </div>
      );
    },
  },
  {
    header: t("Niederlassungen"),
    cell: ({ row }) => {
      const group = row.original;
      return (
        <div className="flex flex-col">
          {group.branches.map((branch) => (
            <BranchName branchId={branch} key={branch} />
          ))}
        </div>
      );
    },
  },
  {
    header: t("Aktionen"),
    cell: ({ row }) => {
      const group = row.original;
      return (
        <span className="space-x-2">
          <PutEntraGroupDialog group={group} />
          <DeleteEntraGroupDialog group={group} />
        </span>
      );
    },
  },
];
